import React, { Component } from 'react';
import {Subtopic, Footer, Button, TextHolder} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';

import cradle from '../../Pictures/cradle.png';
import wtf from '../../Pictures/wtf.png';
import magic from '../../Pictures/magic.png';
import qbo from '../../Pictures/qbo.png';

import leetventures from '../../Pictures/1337ventures.png';
import Acceler from '../../Pictures/acceler8-logo.png';
import AIS from '../../Pictures/AIS.png';
import brainsparks from '../../Pictures/brainsparks.png';
import ChatbotPH from '../../Pictures/ChatbotPH.png';
import codearmy from '../../Pictures/codearmy.png';
import collision from '../../Pictures/collision.png';

import firstfloorcapital from '../../Pictures/firstfloorcapital.png';
import found from '../../Pictures/found.svg';
import GGV from '../../Pictures/ggv.png';
import ideaspace from '../../Pictures/ideaspace.png';
import ih_kl from '../../Pictures/ih_kl.png';
import ih_pp from '../../Pictures/il_pp.png';
import rise from '../../Pictures/rise.png';

import mdec from '../../Pictures/mdec.png';

import svca from '../../Pictures/svca.jpg';
import techsauce from '../../Pictures/techsauce.png';
import th from '../../Pictures/th.png';

import vsv from '../../Pictures/vsv.png';
import worq from '../../Pictures/worq.png';



export class ChapterHundredSixteen extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">

        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {"" }
        </Subtopic>
        <div className="block-outer block-outer-textholder">
          <div className="block-inner block-inner-textholder">

        <a href="http://www.1337accelerator.com/">
        <div className="logo-holder-footer "><img alt="1337 Ventures" src={ leetventures } /></div>
        </a>
        <a href="http://acceler8.ph/home/">
        <div className="logo-holder-footer "><img alt="Acceler8.ph" src={ Acceler } /></div>
        </a>
        <a href="http://www.ais.co.th/thestartup/en/">
        <div className="logo-holder-footer "><img alt="AIS The Startup" src={ AIS } /></div>
        </a>
        <a href="https://www.brainsparks.ph/">
        <div className="logo-holder-footer "><img alt="Brainsparks Philip" src={ brainsparks } /></div>
        </a>
        <a href="http://www.chatbot.ph/">
        <div className="logo-holder-footer "><img alt="ChatbotPH" src={ ChatbotPH } /></div>
        </a>
        <a href="https://codearmy.com/contact-us/">
        <div className="logo-holder-footer "><img alt="Code Army" src={ codearmy } /></div>
        </a>
        <a href="https://www.collision8.com/">
        <div className="logo-holder-footer "><img alt="Collision 8" src={ collision } /></div>
        </a>


        <a href="https://www.cradle.com.my/">
        <div className="logo-holder-footer "><img alt="Cradle" src={ cradle } /></div>
        </a>





        <a href="http://www.firstfloorcapital.com/">
        <div className="logo-holder-footer "><img alt="First Floor Capital" src={ firstfloorcapital } /></div>
        </a>
        <a href="http://www.found.us/homepage">
        <div className="logo-holder-footer "><img alt="Found." src={ found } /></div>
        </a>
        <a href="http://goldengate.vc/">
        <div className="logo-holder-footer "><img alt="Golden Gate Ventures" src={ GGV } /></div>
        </a>

        <a href="http://www.ideaspacefoundation.org/">
        <div className="logo-holder-footer "><img alt="Ideaspace Foundation" src={ ideaspace } /></div>
        </a>
        <a href="https://kualalumpur.impacthub.net/">
        <div className="logo-holder-footer "><img alt="Impact Hub KL" src={ ih_kl } /></div>
        </a>
        <a href="https://phnompenh.impacthub.net/">
        <div className="logo-holder-footer "><img alt="Impact Hub Phnom Penh" src={ ih_pp } /></div>
        </a>
        <a href="http://riseaccel.com/">
        <div className="logo-holder-footer "><img alt="Rise Accelerator" src={ rise } /></div>
        </a>
        <a href="https://mymagic.my/">
        <div className="logo-holder-footer "><img alt="Magic" src={ magic } /></div>
        </a>


        <a href="https://www.mdec.my/">
        <div className="logo-holder-footer "><img alt="MDec" src={ mdec } /></div>
        </a>

        <a href="http://www.qbo.com.ph/">
        <div className="logo-holder-footer "><img alt="QBO" src={ qbo } />
        </div>
        </a>




        <a href="https://www.svca.org.sg/">
        <div className="logo-holder-footer "><img alt="Singapore Venture Capital & Private Equity Association" src={ svca } /></div>
        </a>
        <a href="https://techsauce.co/en/">
        <div className="logo-holder-footer "><img alt="Techsauce" src={ techsauce } /></div>

        </a>
        <a href="http://th.capital/">
        <div className="logo-holder-footer "><img alt="True Happiness Capital" src={ th } /></div>
        </a>
        <a href="http://watchtowerfriends.com/">
        <div className="logo-holder-footer "><img alt="WTF" src={ wtf } /></div>
        </a>




        <a href="http://www.siliconvalley.com.vn/">
        <div className="logo-holder-footer "><img alt="Vietnam Silicon Valley" src={ vsv } /></div>
        </a>
        <a href="https://worq.space/">
        <div className="logo-holder-footer "><img alt="Worq" src={ worq } /></div>
        </a>




        </div>
        </div>

        <TextHolder text="" />


          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/116.js